<p-dialog
  [(visible)]="visible"
  header="{{ 'voting.vote.title' | translate }}"
  [style]="{ 'min-width': '40vw', 'max-width': '80vw' }"
  [draggable]="false"
  [resizable]="false"
  [modal]="true"
  contentStyleClass="p-0"
  (onHide)="onClose()">
  @if (showWarning()) {
    <div class="px-6">
      <p-message severity="error">{{ 'voting.vote.error.nochoice' | translate }}</p-message>
    </div>
  }
  <form class="flex flex-col gap-2 px-6 py-4" [formGroup]="votingForm">
    <div *ngIf="letter.totalVotingDuration > 0">
      <app-progress-bar [step]="progressBarStep()" (timeIsUp)="onFinishVoting()"></app-progress-bar>
    </div>
    <h2 class="w-full">
      {{ letter.formattedTitle }}
    </h2>
    <p-tag
      class="w-max"
      [value]="
        (letter.votingType === 'SECRET'
          ? 'voting.letter.votingtype.secret.display'
          : 'voting.letter.votingtype.public.display'
        ) | translate
      "
      styleClass="p-tag-lg bg-primary-100 text-primary-400"
      [icon]="letter.votingType === 'SECRET' ? 'fa-regular fa-lock-keyhole' : 'fa-regular fa-lock-keyhole-open'">
    </p-tag>
    <p *ngIf="letter.description" [innerHTML]="letter.description | safe: 'html'"></p>
    <div *ngIf="letter.yesno" class="flex w-full justify-center">
      <p-selectButton
        [options]="votingOptions() | removeEmpty"
        optionLabel="label"
        optionValue="value"
        class="p-selectbutton-with-spacing flex-col flex-wrap gap-4 md:flex-row"
        [disabled]="submitVoteLoading"
        [ngModel]="votingFormForActiveMember.value.resultType"
        [ngModelOptions]="{ standalone: true }"
        (onChange)="selectVote($event)"></p-selectButton>
    </div>
    <div *ngIf="!letter.yesno" class="flex flex-col gap-4">
      <div class="candidates-to-select">
        {{ 'voting.result.candidatestoselect.max' | translate: { '0': letter.candidatesToSelect } }}
      </div>
      <div
        *ngFor="let candidate of letter.candidates"
        class="rounded-border flex w-full flex-col items-start justify-between gap-4 bg-white p-4 leading-tight shadow-sm md:flex-row md:items-center">
        <div>
          <strong>{{ candidate.name }}</strong>
          <div>
            <div *ngIf="candidate.informationAvailable">
              {{ candidate.information }}
            </div>
            <div *ngIf="candidate.commentsAvailable" class="text-xs text-gray-600">
              {{ candidate.comments }}
            </div>
          </div>
        </div>
        <div class="flex flex-wrap gap-4">
          <button
            pButton
            icon="fa-regular fa-thumbs-up"
            (click)="toggleCandidate(candidate.id, 'CANDIDATE_FOR')"
            [disabled]="
              (letter.candidates.length > 1 &&
                !votedForCandidate(candidate.id, 'CANDIDATE_FOR') &&
                hasVotedForMaxCandidates()) ||
              submitVoteLoading
            "
            [ngClass]="{
              'p-button-outlined': !votedForCandidate(candidate.id, 'CANDIDATE_FOR')
            }">
            {{ 'voting.result.type.for' | translate }}
          </button>
          <button
            *ngIf="letter.voteAgainstCandidates"
            pButton
            icon="fa-regular fa-thumbs-down"
            (click)="toggleCandidate(candidate.id, 'CANDIDATE_AGAINST')"
            [ngClass]="{
              'p-button-outlined': !votedForCandidate(candidate.id, 'CANDIDATE_AGAINST')
            }">
            {{ 'voting.result.type.against' | translate }}
          </button>
        </div>
      </div>

      <div class="flex w-full flex-col gap-4 pt-4">
        <button
          pButton
          *ngIf="!letter.voteAgainstCandidates"
          icon="fa-regular fa-thumbs-down"
          (click)="toggleVote('AGAINST')"
          [disabled]="submitVoteLoading"
          class="flex justify-center"
          [ngClass]="{
            'p-button-outlined': votingFormForActiveMember.get('resultType').value !== 'AGAINST'
          }">
          {{ 'voting.result.type.against' | translate }}
        </button>
        <button
          pButton
          icon="fa-regular fa-hand"
          (click)="toggleVote('ABSTENTION')"
          [disabled]="submitVoteLoading"
          class="flex justify-center"
          [ngClass]="{
            'p-button-outlined': votingFormForActiveMember.get('resultType').value !== 'ABSTENTION'
          }">
          {{ 'voting.abstent' | translate }}
        </button>
      </div>
    </div>
  </form>

  <div class="mb-4 flex w-full items-center justify-center" *ngIf="letter?.councilMembers?.length > 1">
    <button
      pButton
      class="p-button-outlined"
      icon="fas fa-caret-left"
      (click)="prevMember()"
      [disabled]="activeMemberIndex === 0 || submitVoteLoading || submitVoteError"></button>
    <span class="px-4">
      {{ 'voting.vote.inthenameof' | translate }}&nbsp;<strong>{{ activeMember.name }}</strong>
    </span>
    <button
      pButton
      class="p-button-outlined"
      icon="fas fa-caret-right"
      (click)="nextMember()"
      [disabled]="
        activeMemberIndex === letter?.councilMembers?.length - 1 || submitVoteLoading || submitVoteError
      "></button>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-start">
      <button pButton type="button" (click)="submitVote()" [loading]="submitVoteLoading">
        {{ 'voting.vote.title' | translate }}
      </button>
    </div>
  </ng-template>

  <ng-template pTemplate="closeicon">
    <div
      class="p-dialog-header-icon"
      [title]="
        'dialog.button.close'
          | translate
            : {
                '0': 'voting.vote.title' | translate
              }
      ">
      <i class="fa-regular fa-xmark text-lg text-gray-800"></i>
    </div>
  </ng-template>
</p-dialog>
